import * as Immutable from 'immutable';
import merge from 'lodash/merge';
import {createReducer} from 'redux-store';
import * as ScenariosConstants from '../constants/scenarios-constants';

import type {List, MapOf} from 'immutable';

type Scenario = MapOf<{
    scenarioId: string;
    owner: User;
    organization: Organization;
}>;

type User = MapOf<{
    userId: string;
}>;

type Organization = MapOf<{
    organizationId: string;
    active: boolean;
}>;

export type ScenariosStore = {
    cachedScenarios: List<Scenario>;
    scenarios: List<Scenario>;
    matchingScenariosCount: number;
    organizations: List<Organization>;
    users: MapOf<{
        owner: List<User>;
    }>;
};

const initialState = (): Pick<ScenariosStore, 'cachedScenarios'> => {
    return {
        cachedScenarios: Immutable.List(),
    };
};

const baseState = (): Omit<ScenariosStore, 'cachedScenarios'> => {
    return {
        scenarios: Immutable.List(),
        matchingScenariosCount: 0,
        organizations: Immutable.List(),
        users: Immutable.Map({
            owner: Immutable.List<User>(),
        }),
    };
};

function setOwnerName(scenario) {
    const owner = scenario.get('owner');

    if (owner) {
        const firstName = owner.get('firstName');
        const lastName = owner.get('lastName');

        const ownerName = firstName + ' ' + lastName;

        return scenario.set('ownerName', ownerName);
    } else {
        scenario = scenario.set('owner', {
            firstName: '',
            lastName: '',
        });
        return scenario.set('ownerName', '');
    }
}

function setChecklistCount(scenario) {
    const checklistCount = null;

    return scenario.set('reflections', checklistCount);
}

function addRowAttributes(scenario) {
    const attributes = [setOwnerName, setChecklistCount];

    attributes.forEach((attribute) => {
        scenario = attribute(scenario);
    });

    return scenario;
}

const actionsMap = {
    [ScenariosConstants.SCENARIOS_SUCCESS]: (state, action) => {
        let scenarios = action.data.get('rows').map(addRowAttributes);
        const count = action.data.get('count');

        if (action.query.page !== 0) {
            scenarios = state.scenarios.concat(scenarios);
        }

        return {
            scenarios,
            matchingScenariosCount: count,
        };
    },

    [ScenariosConstants.CACHE_SCENARIOS]: (state, action) => {
        return {
            cachedScenarios: action.data,
        };
    },
    [ScenariosConstants.ORGANIZATIONS_SUCCESS]: (state, action) => {
        return {
            organizations: action.data,
        };
    },

    [ScenariosConstants.USERS_SUCCESS]: (state, action) => {
        let users = state.users;
        users = users.set(action.key, action.data);
        return {
            users,
        };
    },

    [ScenariosConstants.DISPOSE_SCENARIOS_STORES]: () => {
        return baseState();
    },
};

export default createReducer<ScenariosStore>(merge(initialState(), baseState()), actionsMap);
